import React, { useEffect, useRef, useState } from 'react';
import Webcam from "react-webcam";
import Button from 'react-bootstrap/Button';

let videoConstraints = {
    width: 480,
    height: 360,
    facingMode: "environment"
  };
  
export const WebcamCapture = ({ cameraFace,parentCallback,dataParentToChild,multipleImages }) => {
  
        const webcamRef = React.useRef();
        const [imgSrc, setImgSrc] = React.useState([]);
        var imageCaptures = [];
        
        // handle single images ....
        const capture = React.useCallback(() => {
          const imageSrc = webcamRef.current.getScreenshot({width: 800, height: 600});
          setImgSrc(imageSrc);
        }, [webcamRef,setImgSrc]);
      
        videoConstraints.facingMode = cameraFace ? cameraFace : "environment";
        console.log("videoConstraints",multipleImages)

        useEffect(() => {
          dataParentToChild.b64 = imgSrc;
          console.log("previous..imageUploaded",dataParentToChild.imageUploaded)
          dataParentToChild.imageUploaded = imgSrc && imgSrc.toString() == ""  ?  false: true;
          dataParentToChild.cameraToggle = imgSrc && imgSrc.toString() == ""  ?  true: false;
          parentCallback(dataParentToChild);
       }, [imgSrc]);



       const stop = () => {
    
        let webcamRefTemp = webcamRef;
        console.log("webcamRefTemp",webcamRefTemp)
        let stream = webcamRefTemp.current.video.srcObject;
        const tracks = stream.getTracks();
        tracks.forEach(track => track.stop());
        

        dataParentToChild.b64 = imgSrc;
        dataParentToChild.imageUploaded = imgSrc && imgSrc.toString() == ""  ?  false: true;
        dataParentToChild.cameraToggle = false;
        parentCallback(dataParentToChild);

        // webcamRefTemp.video.srcObject = null;
      };

        // handle mutliple images ....
        const [myArray, updateMyArray] = useState([]);

      //   useEffect(() => {
      //     myArray.map( (elem,index) => {
      //     dataParentToChild.b64.push(elem);
      //     console.log("previous..imageUploaded",dataParentToChild.imageUploaded)
      //     dataParentToChild.imageUploaded = elem && elem.toString() == ""  ?  false: true;
      //     dataParentToChild.cameraToggle = elem && elem.toString() == ""  ?  true: false;
      //   });
      //     parentCallback(dataParentToChild);
      //  }, [myArray]);

       

        const onClick = () => {
          const imageSrc = webcamRef.current.getScreenshot({width: 800, height: 600});
          imageCaptures.push(imageSrc);

          updateMyArray( arr => [...arr, `${imageSrc}`]);
      };
    
  


      const stopMutlipleImages = () => {
    
        let webcamRefTemp = webcamRef;
        console.log("webcamRefTemp",webcamRefTemp)
        let stream = webcamRefTemp.current.video.srcObject;
        const tracks = stream.getTracks();
        tracks.forEach(track => track.stop());
        
        myArray.map( (elem,index) => {
        dataParentToChild.b64.push(elem);
        dataParentToChild.imageUploaded = elem && elem.toString() == ""  ?  false: true;
        dataParentToChild.cameraToggle = false;
        })
        parentCallback(dataParentToChild);

        // webcamRefTemp.video.srcObject = null;
      };



        return (
          <div className="text-align-center">
            <Webcam
            audio={false}
            ref={webcamRef}
            videoConstraints={videoConstraints}
             className='width-50' 
            screenshotFormat="image/jpeg"
            />
            <div className="text-align-center p-10">
              {
                multipleImages ? 
                <div className="display-flex justify-content-space-between width-100">
                    <div className='width-48'>
                      <Button variant="danger" block className="border-curve-10" onClick={stopMutlipleImages}>
                          Stop
                      </Button>
                    </div>
                    <div className='width-48'>
                      {/* <input type="button" onClick={ onClick } value="Update" />, */}
                      <Button variant="success" block className="border-curve-10" onClick={onClick}>
                          Capture 
                      </Button>
                    </div>
                </div>
                : 

                <div className="display-flex justify-content-space-between width-100">
                  <div className='width-48'>
                    <Button variant="danger" block className="border-curve-10" onClick={stop}>
                        Stop
                    </Button>
                  </div>
                  <div className='width-48'>
                    {/* <input type="button" onClick={ onClick } value="Update" />, */}
                    <Button variant="success" block className="border-curve-10" onClick={capture}>
                        Capture
                    </Button>
                  </div>
                </div>
              }
              


                {/**
                * handles single image ..
                */}
                <div>
                {
                  imgSrc ? <img className="width-25 p-1" src={imgSrc} /> : ''
                }
                </div>
               
               
               {/**
                * handles mutiple images ..
                */}
                <div className="display-flex flex-wrap justify-content-center p-t-10">
                  <div>{myArray.map( (elem,index) =>
                    <img key={index} className="width-25 p-1" src={elem} />
                  )}
                  </div>
                </div>
            </div>
           
          </div>
        );

  };